import { jsxs as n, jsx as o } from "react/jsx-runtime";
const i = ({
  width: r,
  height: t,
  className: e
}) => /* @__PURE__ */ n(
  "svg",
  {
    className: e,
    fill: "none",
    height: t,
    viewBox: "0 0 19 20",
    width: r,
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ o(
        "path",
        {
          d: "M7.47363 12.5263C8.10521 13.7895 9.36837 13.7895 9.36837 13.7895H10.6315C11.6736 13.7895 12.5263 12.9369 12.5263 11.8948C12.5263 10.8526 11.6736 10 10.6315 10H9.36837C8.32626 10 7.47363 9.14738 7.47363 8.10528C7.47363 7.06317 8.32626 6.21054 9.36837 6.21054H10.6315C10.6315 6.21054 11.8947 6.21054 12.5263 7.4737",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "0.9"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          d: "M10 4.94739V6.21055",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "0.9"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          d: "M10 13.7895V15.0526",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "0.9"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          d: "M6 3.06842C7.17895 2.38947 8.54211 2 10 2C14.4158 2 18 5.58421 18 10C18 14.4158 14.4158 18 10 18C5.58421 18 2 14.4158 2 10C2 8.62632 2.34737 7.33684 2.95263 6.21053",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "0.9"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          d: "M7.47363 12.5263C8.10521 13.7895 9.36837 13.7895 9.36837 13.7895H10.6315C11.6736 13.7895 12.5263 12.9369 12.5263 11.8948C12.5263 10.8526 11.6736 10 10.6315 10H9.36837C8.32626 10 7.47363 9.14738 7.47363 8.10528C7.47363 7.06317 8.32626 6.21054 9.36837 6.21054H10.6315C10.6315 6.21054 11.8947 6.21054 12.5263 7.4737",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "0.9"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          d: "M10 4.94739V6.21055",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "0.9"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          d: "M10 13.7895V15.0526",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "0.9"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          d: "M6 3.06842C7.17895 2.38947 8.54211 2 10 2C14.4158 2 18 5.58421 18 10C18 14.4158 14.4158 18 10 18C5.58421 18 2 14.4158 2 10C2 8.62632 2.34737 7.33684 2.95263 6.21053",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "0.9"
        }
      )
    ]
  }
);
export {
  i as Content
};
